export default "__VITE_ASSET__ir4E3G6q__"